import React from "react";
import { names } from "../../../helpers/StringHelper";

class TableHead extends React.Component {
  render() {
    let { fields, params, onClick, noActions, values, title } = this.props;

    return (
      <thead id={title ? "backup-table-head" : ""}>
        <tr>
          {fields.map((field) => {
            return (
              <th
                scope="col"
                key={field.field}
                className={`pointer ${names(
                  params.sort_id === field.field &&
                    params.sort_order === `desc` &&
                    "th-active-desc",
                  params.sort_id === field.field &&
                    params.sort_order === `asc` &&
                    "th-active-asc",
                  field.sort && `th-sortable`
                )}`}
                onClick={() => field.sort && onClick && onClick(field.field)}
              >
                {field.label}
              </th>
            );
          })}

          {values &&
            values.map((l) => {
              return <th>{l}</th>;
            })}

          <th>Action</th>

          {!noActions && <th>Action</th>}
        </tr>
      </thead>
    );
  }
}
export default TableHead;
